import { app, authentication } from '@microsoft/teams-js';
/** O Teams pode mandar campos vazios em vez de omiti-los. */
const orNull = (value) => value?.trim() || null;
function snapshotOf(context) {
    return {
        user: {
            id: orNull(context.user?.id),
            displayName: orNull(context.user?.displayName),
            userPrincipalName: orNull(context.user?.userPrincipalName),
            loginHint: orNull(context.user?.loginHint),
            tenantId: orNull(context.user?.tenant?.id),
            licenseType: orNull(context.user?.licenseType),
        },
        app: {
            locale: orNull(context.app.locale),
            theme: orNull(context.app.theme),
            sessionId: orNull(context.app.sessionId),
            hostName: orNull(context.app.host.name),
            clientType: orNull(context.app.host.clientType),
        },
        page: {
            id: orNull(context.page.id),
            frameContext: orNull(context.page.frameContext),
        },
        // Só dados: o SDK não põe funções no contexto, mas a cópia garante.
        raw: JSON.parse(JSON.stringify(context)),
    };
}
/**
 * Só se tenta falar com o Teams dentro de um iframe ou webview. Lá, num iframe
 * que não é do Teams, o `app.initialize()` não falha: fica esperando um host
 * que nunca responde, e o limite evita a tela inicial presa. O Teams na web,
 * ao carregar a aba pela primeira vez, pode levar vários segundos para
 * responder; um limite curto faria a aplicação achar que está fora dele.
 */
const INITIALIZE_TIMEOUT_MS = 15_000;
const toTheme = (value) => value === 'dark' || value === 'contrast' ? value : 'light';
/** Dentro do Teams a aplicação roda num iframe ou num webview do app móvel. */
function mightBeInTeams() {
    return window.self !== window.top || 'nativeInterface' in window;
}
async function initialize() {
    let timer;
    const timeout = new Promise((resolve) => {
        timer = setTimeout(() => resolve(false), INITIALIZE_TIMEOUT_MS);
    });
    try {
        return await Promise.race([app.initialize().then(() => true), timeout]);
    }
    catch {
        return false;
    }
    finally {
        clearTimeout(timer);
    }
}
async function connect() {
    if (!(mightBeInTeams() && (await initialize()))) {
        return null;
    }
    const context = await app.getContext();
    const listeners = new Set();
    app.registerOnThemeChangeHandler((theme) => {
        for (const listener of listeners) {
            listener(toTheme(theme));
        }
    });
    // Tira a tela de carregamento do Teams assim que o app está pronto.
    app.notifySuccess();
    return {
        theme: toTheme(context.app.theme),
        onThemeChange(listener) {
            listeners.add(listener);
            return () => listeners.delete(listener);
        },
        getAuthToken: () => authentication.getAuthToken(),
        context: snapshotOf(context),
    };
}
let connection;
/** Conecta uma vez só; as chamadas seguintes reaproveitam o resultado. */
export function connectToTeams() {
    connection ??= connect();
    return connection;
}
//# sourceMappingURL=teams-host.js.map